import { SvgIcon, Theme, useTheme } from '@mui/material';
import React from 'react';
import CommonButtonProps from './ETOButtonCommonProps';
import commonButtonStyles from './ETOButtonCommonStyles';

const iconWrapperSx = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  '& MuiSvgIcon-root': {
    fontSize: '0px',
  },
};

const iconSizeSx = (theme: Theme, size: 'small' | 'medium' | 'large') => {
  switch (size) {
    case 'small':
      return { fontSize: theme.spacing(2) };
    case 'large':
      return { fontSize: theme.spacing(3) };
    default:
      return { fontSize: theme.spacing(2.5) };
  }
};

interface IconWrapperProps extends Pick<CommonButtonProps, 'size' | 'loading'> {
  children: React.ReactNode;
}

const IconWrapper: React.FC<React.PropsWithChildren<IconWrapperProps>> = (props) => {
  const { children, size, loading } = props;

  const theme = useTheme();
  const commonStyles = commonButtonStyles(theme);

  return (
    <SvgIcon
      data-testid="icon"
      sx={[
        iconWrapperSx,
        iconSizeSx(theme, size),
        { ...(loading && commonStyles.loading) },
      ]}
    >
      {children}
    </SvgIcon>
  );
};

export default IconWrapper;
